import { useTranslation } from 'react-i18next';
import { InstagramAnalyticsPostsInDate } from '@anytag/graphql';
import { PostModal } from '../shared';
import { FeedPostTemplate } from './feed-post-template';
import { ReelPostTemplate } from './reel-post-template';
import { StoryPostTemplate } from './story-post-template';

enum InstagramPostInDateDetailsType {
  feedPost = 'feedPost',
  reelPost = 'reelPost',
  storyPost = 'storyPost'
}

export interface InstagramPostInDateDetailsModalProps {
  paramKey?: string;
  data: InstagramAnalyticsPostsInDate | null;
}

export const InstagramPostInDateDetailsModal = ({ data, paramKey }: InstagramPostInDateDetailsModalProps) => {
  const { t } = useTranslation();

  const posts = [
    ...(data?.feedPosts?.map((post) => ({ ...post, type: InstagramPostInDateDetailsType.feedPost })) || []),
    ...(data?.storyPosts?.map((post) => ({ ...post, type: InstagramPostInDateDetailsType.storyPost })) || []),
    ...(data?.reelPosts?.map((post) => ({ ...post, type: InstagramPostInDateDetailsType.reelPost })) || [])
  ];

  return (
    <PostModal posts={posts} paramKey={paramKey}>
      {({ selectedPost, closeModal }) => (
        <>
          <PostModal.Title>{t('Post Detail')}</PostModal.Title>

          {selectedPost.type === InstagramPostInDateDetailsType.feedPost ? (
            <FeedPostTemplate
              onCloseModal={closeModal}
              data={data?.feedPosts?.find((post) => post.id === selectedPost.id)}
            />
          ) : selectedPost.type === InstagramPostInDateDetailsType.storyPost ? (
            <StoryPostTemplate
              onCloseModal={closeModal}
              data={data?.storyPosts?.find((post) => post.id === selectedPost.id)}
            />
          ) : selectedPost.type === InstagramPostInDateDetailsType.reelPost ? (
            <ReelPostTemplate
              onCloseModal={closeModal}
              data={data?.reelPosts?.find((post) => post.id === selectedPost.id)}
            />
          ) : null}
        </>
      )}
    </PostModal>
  );
};
